import { TestSuiteStatus } from 'store/src/lib/tests/entity';
import TestStatusBadge from './test-status-badge';
import { TestCountVariant } from '@/components/raytd/test-count-pill';

const StatusBadges = ({ status }: { status: TestCountVariant }) => {
    return (
        <div className="w-20 flex items-center justify-end">
            <TestStatusBadge
                key={status}
                status={status.toLowerCase()}
            />
        </div>
    )
}

export default StatusBadges;